export default "__VITE_ASSET__BzMv2trE__"